<template>
  <div
    class="vb-icon"
    :class="dotted ? 'vb-icon--dotted' : ''"
    :style="`
      --size:${size}px; 
      --dot-size:${dot_size}px; 
      --color: ${parsed_color}; 
      ${Object.entries(icon_style).map(
        (entry) => ` ${entry[0]}: ${entry[1]}; `,
      )}
    `"
    @click="
      ($event) => {
        if (this.$listeners.click) {
          this.$listeners.click($event);
        }
      }
    "
    v-html="Icons[name.replace('-', '_')]"
  >
  </div>
</template>

<script>
import * as DesignIcons from "./design-icons";
import * as CreditCards from "./credit-cards";
import * as CustomIcons from "./custom-icons";
import { theme_mixin } from "@/components/blocks/content-theme";

export default {
  name: "vb-icon",
  mixins: [theme_mixin],
  props: {
    name: String,
    size: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: "000000",
    },
    dotted: Boolean,
    dot_size: {
      type: Number,
      default: 10,
    },
    icon_style: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      color_ui: this.color,
      color_map: {
        primary: this.sass("primary"),
        secondary: this.sass("secondary"),
        info: this.sass("info"),
      },
    };
  },
  computed: {
    parsed_color() {
      return this.color_ui.includes('--')
          ? `var(${this.color_ui})`
          : `#${this.color_ui.replace('#', '')}`
    }
  },
  watch: {
    color() {
      this.check_body_class();
    },
    theme_colors() {
      this.$nextTick(() => this.check_body_class());
    },
  },
  created() {
    this.Icons = {
      ...DesignIcons,
      ...CreditCards,
      ...CustomIcons,
    };
  },
  mounted() {
    if (this.check_body_class()) return;
    this.observe_customizations();
  },
  destroyed() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    observe_customizations() {
      const observer = new MutationObserver(() => {
        this.check_body_class();
      });
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
      this.observer = observer;
    },
    check_body_class() {
      const is_customized = document.body.classList.contains("customized");
      this.color_ui = this.color;
      if (is_customized) {
        if (this.color === this.color_map.primary) {
          this.color_ui = this.theme_colors.primary || this.color;
        }
        if (this.color === this.color_map.secondary) {
          this.color_ui = this.theme_colors.secondary || this.color;  
        }
        if (this.color === this.color_map.info) {
          this.color_ui = this.theme_colors.info || this.color;
        }
      }
      return is_customized;
    },
  },
};
</script>

<style lang="scss">
.vb-icon {
  svg {
    width: var(--size);
    height: var(--size);
  }

  &--dotted {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      right: 0;
      width: var(--dot-size);
      height: var(--dot-size);
      background-color: var(--secondary);
      border-radius: 100%;
    }
  }
}
</style>
